import { z } from "zod";
/** Строка view `v_corp_companies` (контракт v2.0 §4.2) — без финансов (D14). */
export const zCorpCompanyRowDto = z.object({
    id: z.string(),
    name: z.string(),
    legal_name: z.string().nullish(),
    inn: z.string().nullish(),
    kpp: z.string().nullish(),
    ogrn: z.string().nullish(),
    legal_address: z.string().nullish(),
    bank_details: z.record(z.string(), z.unknown()).nullish(),
    contact_name: z.string().nullish(),
    contact_phone: z.string().nullish(),
    contact_email: z.string().nullish(),
    contract_number: z.string().nullish(),
    contract_date: z.string().nullish(),
    comment: z.string().nullish(),
    status: z.string(),
    status_reason: z.string().nullish(),
    status_changed_at: z.string().nullish(),
    credit_state: z.string(),
    active_links_count: z.number(),
    admins_count: z.number(),
    open_orders_count: z.number(),
    created_at: z.string(),
    updated_at: z.string(),
});
/** Ответ `corp_company_create` (§4.3). */
export const zCompanyCreateResultDto = z.object({
    companyId: z.string(),
    tariff: z.object({
        idAdvance: z.string(),
        idLateTariff: z.string().nullish(),
    }),
});
/**
 * Ответ `corp_company_set_status` (§4.3): `{companyId, status, openOrders, balance}`.
 * `linksEnded` на TEST (2026-09-19) не возвращается — ключ читается, если появится.
 */
export const zCompanySetStatusResultDto = z.object({
    companyId: z.string(),
    status: z.string(),
    openOrders: z.number(),
    linksEnded: z.number().nullish(),
});
/** Ответ `corp_tariff_pair_upsert` (§4.3). */
export const zCompanyTariffResultDto = z.object({
    idAdvance: z.string(),
    idLateTariff: z.string().nullish(),
});
